import { useTranslation } from 'react-i18next';
import MasterLayout from '../components/layouts/MasterLayout';
import PageHeader from '../components/layouts/PageHeader';
import ProductList from '../components/products/ProductList';
// import ProductList from '../components/products/ProductList';
const DownloadsPage = () => {
    const { t } = useTranslation();


    const downloadList = JSON.parse(localStorage.getItem('downloads'))
    let ids = []
    const downloaded = downloadList?.filter((value,index)=>{
        if(ids.includes(value.id)){
            return false;
        }
        ids.push(value.id)
        return true;
    })

    
    return (
        <MasterLayout>
            <PageHeader title={t('download.my_downloads')} />
            <ProductList data={downloaded} collectionData={{isCollection:false , name:'Downloads' , pagination:false}}/>
        </MasterLayout>
    );
};

export default DownloadsPage;
